import React, { useEffect, useState } from 'react';

import { Box, CircularProgress, Typography } from 'components';

import { useNavigate, useSearchParams, useTranslation } from 'third-party';

import { loginUrl, tenantDashboardUrl } from 'constants/url';

import { useApp } from 'modules/app';

import { saveUserToken } from 'utils/auth';

export const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { userInfo, selectTenant } = useApp();
  const [error, setError] = useState<string | null>(null);

  const { t } = useTranslation();

  useEffect(() => {
    const processCallback = async () => {
      const token = searchParams.get('token');
      const errorParam = searchParams.get('error');

      if (errorParam) {
        setError(`${t('auth.failedToAuthenticate')}: ${errorParam}`);
        setTimeout(() => {
          navigate(loginUrl());
        }, 3000);
        return;
      }

      if (!token) {
        setError(t('auth.noAuthTokenReceived'));
        setTimeout(() => {
          navigate(loginUrl());
        }, 3000);
        return;
      }

      try {
        saveUserToken(token);
        const infoResult = await userInfo();
        const firstTenant = infoResult.payload?.userTenants?.[0];
        if (firstTenant) {
          selectTenant(firstTenant.tenant.id);
          navigate(tenantDashboardUrl(firstTenant.tenant.id));
        } else {
          navigate(loginUrl());
        }
      } catch {
        setError(t('auth.failedToAuthenticate'));
        setTimeout(() => {
          navigate(loginUrl());
        }, 3000);
      }
    };

    processCallback();
  }, [searchParams, navigate, userInfo, t]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100%"
      width="100%"
      gap="2rem"
    >
      {error ? (
        <>
          <Typography variant="h5" color="error">
            {error}
          </Typography>
          <Typography variant="body1">{t('auth.redirecting')}</Typography>
        </>
      ) : (
        <>
          <CircularProgress size={60} />
          <Typography variant="h5">{t('auth.completingSignIn')}</Typography>
        </>
      )}
    </Box>
  );
};
